import * as fabric from 'office-ui-fabric-react';
import { FC, useEffect } from 'react';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import { useNavigate, useParams } from 'react-router-dom';
import * as api from '../../api/generated';
import { Role } from '../../enums';
import Evacuation from '../../features/administration/organization/evacuation/Evacuation';
import { getOrganizationName, getSideBar, setOrganizationName } from '../../utils';
import { useAuthentication } from '../authentication';
import * as components from '../index';
import { KendoLoading } from '../index';

export const OrganizationLayout: FC = (props) => {
    const organizationName = getOrganizationName();
    const { organizationId } = useParams<'organizationId'>();

    const fetchData = async () => {
        try {
            if (organizationId) {
                const organization = await api.administration.getOrganization(parseInt(organizationId.toString()));
                setOrganizationName(organization && organization.name ? organization.name : '');
            }
        } catch (ex) {
            console.log(ex);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <AppLayout>
            <div style={{ margin: '15px 10px' }}>
                <fabric.Stack horizontal horizontalAlign="space-between">
                    <fabric.StackItem>
                        <fabric.Text style={{ fontWeight: 'lighter' }} variant="xxLarge">
                            {organizationId ? organizationName.length ? `Organizacija - ${organizationName}` : <KendoLoading /> : null}
                        </fabric.Text>
                    </fabric.StackItem>
                    <fabric.StackItem styles={{ root: { marginRight: '10px' } }}>
                        {organizationId && <Evacuation organizationId={parseInt(organizationId.toString())}></Evacuation>}
                    </fabric.StackItem>
                </fabric.Stack>

                <components.CommandBar />
                <div style={{ marginTop: '10px' }} className="ms-Grid ms-depth-4" dir="ltr">
                    <fabric.Stack tokens={{ padding: '5px' }}>{props.children}</fabric.Stack>
                </div>
            </div>
        </AppLayout>
    );
};

export const QueueLayout: FC = (props) => {
    return (
        <>
            <fabric.Stack horizontal>
                <fabric.Stack style={{ marginLeft: '10px' }}>
                    <fabric.Stack.Item></fabric.Stack.Item>
                    {props.children}
                </fabric.Stack>
            </fabric.Stack>
        </>
    );
};

export const AppLayout: FC = (props) => {
    const isSidebarShown = getSideBar();

    const { assembly, hasAccess } = useAuthentication();
    const navigate = useNavigate();

    if (hasAccess(Role.Employee)) {
        navigate('/queuesManagement');
    }

    if (!hasAccess(Role.Administrator, Role.Manager)) {
        // return null;
    }

    return (
        <div style={{ padding: '0px 15px' }}>
            <components.Navbar />
            <hr />
            <fabric.Stack style={{ minHeight: '85vh' }} horizontal>
                <fabric.Stack.Item
                    styles={{
                        root: {
                            backgroundColor: fabric.getTheme().palette.white,
                            width: isSidebarShown ? '280px!important' : '50px',
                            minWidth: '50px',
                            maxWidth: '280px',
                            overflow: 'hidden',
                            transition: '0.5s'
                        }
                    }}
                >
                    <components.Sidebar />
                </fabric.Stack.Item>
                <fabric.Stack style={{ marginLeft: '10px', overflowX: 'hidden' }} grow>
                    <fabric.Stack.Item>{props.children}</fabric.Stack.Item>
                </fabric.Stack>
            </fabric.Stack>
            <div className="footer" style={{ width: '100%' }}>
                <fabric.Separator>
                    <fabric.Text>
                        <>Versija: {assembly}</>
                    </fabric.Text>
                </fabric.Separator>
            </div>
        </div>
    );
};
